/**
 * User Profile Component
 */

import { cn, User } from '@ufc/uikit'
import type { UserProfileProps } from '../types'

function getContainerStyles(isRTL: boolean): string {
  return cn(
    'flex items-center gap-4 ps-4 ms-2 border-s border-border/50',
    isRTL && 'flex-row-reverse'
  )
}

function getTextAlignment(isRTL: boolean): string {
  return cn('text-end', isRTL && 'text-start')
}

export function UserProfile({ name, role, isRTL }: UserProfileProps) {
  return (
    <div className={getContainerStyles(isRTL)}>
      <div className={getTextAlignment(isRTL)}>
        <p className="text-sm font-semibold text-foreground">{name}</p>
        <p className="text-xs text-muted-foreground">{role}</p>
      </div>
      <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-primary/30 to-primary/10 dark:from-primary/40 dark:to-primary/20 flex items-center justify-center ring-2 ring-primary/20 dark:ring-primary/30">
        <User className="w-5 h-5 text-primary" />
      </div>
    </div>
  )
}

/**
 * Mobile User Avatar (simplified version)
 */
export function MobileUserAvatar() {
  return (
    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary/30 to-primary/10 dark:from-primary/40 dark:to-primary/20 flex items-center justify-center ring-2 ring-primary/20 dark:ring-primary/30">
      <User className="w-4 h-4 text-primary" />
    </div>
  )
}

